import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { TooltipedElementComponent } from 'commons/components/tooltiped-element';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';
import { DeviceConfigurationInfo } from '../settings-devices-configuration-list/settings-devices-configuration-list.model';

export interface BulkActivateDeactivateConfigurationComponentProps {
    selectedRows: DeviceConfigurationInfo[];
    isDefaultSelected: boolean;
    onClick: VoidFunction;
}

export const BulkActivateDeactivateConfigurationComponent: React.FC<
    BulkActivateDeactivateConfigurationComponentProps
> = (props) => {
    const { isDefaultSelected, onClick, selectedRows } = props;

    const { t } = useTranslation();
    const allActivate = selectedRows.every((row) => row.active);
    const allDeactivate = selectedRows.every((row) => !row.active);
    const areMixedSelection = !allActivate && !allDeactivate;
    const getTooltipText = React.useCallback(() => {
        if (isDefaultSelected) {
            return t(
                'settings.devices.device-settings.device-config-list.action.activate-deactivate.by-default-warning'
            );
        }
        if (areMixedSelection) {
            return t('settings.devices.device-settings.device-config-list.action.activate-deactivate.mixed-warning');
        }
        return '';
    }, [isDefaultSelected, areMixedSelection, t]);
    return (
        <TooltipedElementComponent
            hideTooltip={!isDefaultSelected && !areMixedSelection}
            tooltipText={getTooltipText()}
        >
            <PocButton
                className="bulk-action"
                data-testid="bulk-action-activate-deactivate"
                variant="tertiary"
                size="medium"
                onClick={onClick}
                {...(isDefaultSelected || areMixedSelection ? { disabled: true } : {})}
            >
                <PocIcon slot="prefix" name={allActivate ? 'circle_remove' : 'iso_on_off'} family="outlined" />

                {t(
                    `settings.devices.device-settings.device-config-layout.bulk.action.${
                        allActivate ? 'deactivate' : 'activate'
                    }`
                )}
            </PocButton>
        </TooltipedElementComponent>
    );
};
